import { Breakpoint, breakpoints, pxToRem } from "@ottatech/design";
import { useEffect, useMemo, useState } from "react";

type Query = { to: Breakpoint } | { from: Breakpoint };

export function useMedia(query: Query): boolean | null {
  const [matches, setMatches] = useState<boolean>(false);

  const qs = useMemo(
    () =>
      "to" in query
        ? `(max-width: ${pxToRem(breakpoints[query.to])})`
        : `(min-width: ${pxToRem(breakpoints[query.from])})`,
    [query]
  );

  useEffect(() => {
    const m = window.matchMedia(qs);

    const listener = (e: { matches: boolean }) => {
      setMatches(e.matches);
    };

    listener(m);

    if (typeof m.addEventListener === "function") {
      m.addEventListener("change", listener);

      return () => {
        m.removeEventListener("change", listener);
      };
    }
    m.addListener(listener);

    return () => {
      m.removeListener(listener);
    };
  }, [qs]);

  if (typeof window === "undefined") {
    return null;
  }

  return matches;
}
